export const getPathInspectorWebEndpoint = (
  table: string,
): string | undefined => {
  switch (table) {
    case 'vRoute':
      return '/technology/routing/routes';
    case 'vRouteIpv6':
      return '/technology/routing/routes/ipv6';
    case 'vArp':
      return '/technology/addressing/arp-table';
    case 'vMac':
      return '/technology/addressing/mac-table';
    case 'vMulticastRoute':
      return '/technology/multicast/mroute/table';
    case 'vIgmpSnoopingGroup':
      return '/technology/multicast/igmp/snooping/groups';
    case 'vMplsForwarding':
      return '/technology/mpls/forwarding';
    case 'vAciEndpoint':
      return '/technology/sdn/aci/endpoint';
    case 'vFabricPathRoutes':
      return '/technology/platforms/cisco-fabric-path/routes';
    case 'vLispLocal':
      return '/technology/routing/lisp/routes/ipv4';
    case 'vLispRemote':
      return '/technology/routing/lisp/map-resolvers/ipv4';
    case 'vNeighborDiscovery':
      return '/technology/addressing/ipv6-neighbor-discovery';
    case 'vSpbmBMac':
      return '/technology/spbm/bmac';
    case 'vSpbmISid':
      return '/technology/spbm/services';
    default:
      return undefined;
  }
};
